module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="25.03" height="42.969" viewBox="0 0 25.03 42.969"><path class="cls-1" d="M1.01 40.527l20.1-19.035L1.01 2.457" fill="none" stroke="#6d1c83" stroke-width="2"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-slide.svg
// module id = 513
// module chunks = 1